import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import React from 'react';
import toast from 'react-hot-toast';
import { Booth } from '../../../../interfaces/interfaces';
import { fetchAndSetAdminBooth } from '../../../../reduxToolkit/slices/adminSlice';
import { setBooths } from '../../../../reduxToolkit/slices/commonSlice';
import { useDispatch, useSelector } from '../../../../reduxToolkit/typedRedux';
import { updateBooth } from '../../../../services/services';
import BoothVideos from './BoothVideos/BoothVideos';
import { BoothWebsite } from './BoothWebsite';

const VyRichTextEditor = dynamic(() => import('../../../common/VyRichTextEditor'), {
  ssr: false,
  loading: () => <p>loading...</p>,
});

interface BoothVideoAndRichtextProps {
  booth: Booth;
  isInline?: boolean;
  hideBoothVideos?: boolean;
  hideBoothWebsite?: boolean;
  hideBoothDescription?: boolean;
  onRefresh?: () => void;
}

const BoothVideoAndRichtext = ({ booth, isInline, hideBoothVideos, hideBoothWebsite, hideBoothDescription, onRefresh }: BoothVideoAndRichtextProps) => {
  const booths = useSelector((state) => state.common.booths);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  async function updateDescription(description: string) {
    const _booth = await updateBooth({ boothid: booth._id, description });
    const _booths = booths.map((b) => (b._id === _booth._id ? _booth : b));
    dispatch(setBooths(_booths));
    refresh();
    toast.success(t('feedback:changes-saved'));
  }

  function refresh() {
    !isInline && dispatch(fetchAndSetAdminBooth({ boothid: booth?._id }));
  }

  return (
    <div className="flex flex-col items-center justify-center w-full gap-4 my-4">
      {!hideBoothVideos && <BoothVideos booth={isInline ? booth : undefined} isInline={isInline} onRefresh={onRefresh} />}
      <div className="w-full mx-0 my-0">
        {!hideBoothDescription && <VyRichTextEditor defaultValue={booth.description || ''} onBlur={updateDescription} id="description" />}
        {!hideBoothWebsite && <BoothWebsite booth={booth} onUpdate={refresh} isInline={isInline} />}
      </div>
    </div>
  );
};

export default BoothVideoAndRichtext;
